import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

const noop = () => {
};

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

@Component({
    selector: 'my-flavor-multiselect',
    templateUrl: './FlavorMultiSelect.component.html'
})
export class FlavorMultiSelectComponent implements OnInit {

    //The internal data model
    private innerValue: any = '';

    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.valueChange.emit(v);
            this.onChangeCallback(v);
        }
    }

    //Set touched on blur
    onBlur() {
        this.onTouchedCallback();
    }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    @Input() public selectedIDs: number[] = [];
    @Output() public valueChange: EventEmitter<number> = new EventEmitter();

    selectItems: SelectItem[] = [];
    flavors: ent.Flavor[] = [];

    constructor(private domainDataService: serv.DomainDataService) {
    }


    ngOnInit(): void {
        this.load();
    }

    public load() {

        this.domainDataService.getFlavors({ IncludeInactive: false, IncludeFountainAvailableOnly: true }).subscribe(x => this.onGetRecordsDone(x));
    }

    onGetRecordsDone(items: ent.Flavor[]) {
        this.flavors = items;
        // this.selectItems.push({label:"", value:Constants._NONE});
        items.forEach(y => this.selectItems.push({ label: y.FullName, value: y.ID }))
    }

}